
(function () {

  let suppressAutoOpen = false;

  document.addEventListener(
    'cart:change',
    function (event) {
      if (event.detail && event.detail.baseEvent === 'variant:add') {
        suppressAutoOpen = true;
        setTimeout(function () {
          suppressAutoOpen = false;
        }, 0);
      }
    },
    true
  );

  customElements.whenDefined('cart-drawer').then(function () {
    const CartDrawerClass = customElements.get('cart-drawer');
    const originalShow = CartDrawerClass.prototype.show;

    CartDrawerClass.prototype.show = function (...args) {
      if (suppressAutoOpen) {
        return Promise.resolve();
      }
      return originalShow.apply(this, args);
    };
  });

  function openCartDrawer() {
    customElements.whenDefined('cart-drawer').then(function () {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      }
    });
  }

  const FLAG_KEY = 'cw_open_cart_after_reload';

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cw-popup-product-add-to-cart-button');
    if (btn) {
      sessionStorage.setItem(FLAG_KEY, '1');
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    if (sessionStorage.getItem(FLAG_KEY) === '1') {
      sessionStorage.removeItem(FLAG_KEY);
      openCartDrawer();
    }
  });

  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.cw-close-button');
    if (closeBtn) {
      openCartDrawer();
    }
  }, true);
})();
